import * as Sentry from '@sentry/nextjs'
import React from 'react'

interface State {
  hasError: boolean
}

interface Props {
  children: React.ReactNode
  name?: string
}

export class ErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Error)
      scope.setTag('caughtInBoundary', this.props.name || 'unnamed boundary')
      Sentry.captureException(error)
    })
  }

  render() {
    return this.state.hasError ? null : this.props.children
  }
}
